export enum MajorEnum {
    ACCOUNTING = 'accounting',
    ACTUARIAL_SCIENCE = 'actuarialScience',
    AEROSPACE_ENGINEERING = 'aerospaceEngineering',
    ANTHROPOLOGY = 'anthropology',
    APPLIED_MATHEMATICS = 'appliedMathematics',
    ASTRONOMY = 'astronomy',
    AUDIT = 'audit',
    BIOLOGY = 'biology',
    BIOMEDICAL_ENGINEERING = 'biomedicalEngineering',
    BUSINESS_ADMINISTRATION = 'businessAdministration',
    BUSINESS_ANALYTICS = 'businessAnalytics',
    BUSINESS_INTELLIGENCE = 'businessIntelligence',
    BUSINESS_GENERAL = 'businessGeneral',
    CHEMICAL_ENGINEERING = 'chemicalEngineering',
    CHEMISTRY = 'chemistry',
    CIVIL_ENGINEERING = 'civilEngineering',
    COMMERCE = 'commerce',
    COMMUNICATION = 'communication',
    COMPUTER_ENGINEERING = 'computerEngineering',
    COMPUTER_SCIENCE = 'computerScience',
    COMPUTER_SYSTEM_ADMINISTRATION = 'computerSystemAdministration',
    CREATIVE_WRITING = 'creativeWriting',
    CRIMINOLOGY = 'criminology',
    CYBERSECURITY = 'cybersecurity',
    DATA_MANAGEMENT = 'dataManagement',
    DATA_SCIENCE_ANALYTICS = 'dataScienceAnalytics',
    ECOLOGY = 'ecology',
    ECONOMICS = 'economics',
    EDUCATION = 'education',
    ELECTRICAL_ENGINEERING = 'electricalEngineering',
    ENGINEERING_GENERAL = 'engineeringGeneral',
    ENGLISH_LANGUAGE_LITERATURE = 'englishLanguageLiterature',
    ENVIRONMENTAL_ENGINEERING = 'environmentalEngineering',
    FINANCE = 'finance',
    GENETICS = 'genetics',
    GEOGRAPHY = 'geography',
    GEOLOGY = 'geology',
    HISTORY = 'history',
    INDUSTRIAL__ENGINEERING = 'industrialEngineering',
    INFORMATION_MANAGEMENT = 'informationManagement',
    INFORMATION_SYSTEMS = 'informationSystems',
    INFORMATION_TECHNOLOGY = 'informationTechnology',
    INTERNATIONAL_RELATIONS = 'internationalRelations',
    LAW = 'law',
    LEGAL_STUDIES = 'legalStudies',
    LINGUISTICS = 'linguistics',
    MARKETING = 'marketing',
    MATHEMATICS = 'mathematics',
    MECHANICAL_ENGINEERING = 'mechanicalEngineering',
    MEDICINE = 'medicine',
    NURSING = 'nursing',
    ORGANIZATIONAL_BEHAVIOR = 'organizationalBehavior',
    PHILOSOPHY = 'philosophy',
    PHYSICAL_SCIENCES = 'physicalSciences',
    PHYSICS = 'physics',
    POLITICAL_SCIENCE = 'politicalScience',
    PSYCHOLOGY = 'psychology',
    REAL_ESTATE = 'realEstate',
    RELIGION = 'religion',
    SOCIOLOGY = 'sociology',
    STATISTICS = 'statistics',
    SUPPLY_CHAIN_MANAGEMENT = 'supplyChainManagement',
    TAX = 'tax',
    THEOLOGY = 'theology',
    URBAN_STUDIES = 'urbanStudies',
    OTHER = 'other',
}
